import * as React from 'react'
import LockIcon from '@mui/icons-material/Lock';
import Backdrop from '@mui/material/Backdrop';
import UserUnsubscriptionAd from '../LookupReport/components/advertisement/UserUnsubscribedAd';

type Props = {
  className?: string,
}



const GoldLockProtectionIcon: React.FC<Props> = ({ className = '' }) => {
  const [open, setOpen] = React.useState<boolean>(false);




  return (
    <React.Fragment>
      <LockIcon
        fontSize="inherit" color="inherit"
        className={`${className} text-yellow-400 cursor-pointer`}
        onClick={() => setOpen(true)}
      />
      {open &&
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          onClick={() => {
            setOpen(false);
          }}
          className='text-black text-left'
        >
          <div className="text-black text-left inline-block" onClick={(e) => e.stopPropagation()}>
            <UserUnsubscriptionAd onClose={() => {
              console.log('Close')
              setOpen(false);
            }} />
          </div>
        </Backdrop>
      }

    </React.Fragment>


  );
}

export default GoldLockProtectionIcon;

